import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Skeleton from '@mui/material/Skeleton'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { getRace } from '../../api/races'
import UploadWidget from '../../components/PhotoDistribution/UploadWidget'
import { PHOTO_DIST_API_BASE, PHOTO_DIST_ORG } from '../../config'

const PhotoUpload = () => {
  const { t } = useTranslation('race')
  const { name } = useParams()
  const [race, setRace] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    let active = true
    if (!name) {
      setError(true)
      setLoading(false)
      return
    }
    getRace(name)
      .then(data => { if (active) setRace(data) })
      .catch(() => { if (active) setError(true) })
      .finally(() => { if (active) setLoading(false) })
    return () => { active = false }
  }, [name])

  if (loading) {
    return (
      <Container maxWidth='xl' sx={{ mt: 8 }}>
        <Skeleton variant='rectangular' height={320} />
      </Container>
    )
  }

  if (error || !race) {
    return (
      <Container maxWidth='xl' sx={{ mt: 8 }}>
        <Typography variant='h5'>{t('media.uploadNotFound')}</Typography>
      </Container>
    )
  }

  // The photographer upload is tied to the same eventId/orgId pair the runner
  // gallery uses, so photos uploaded here become searchable on /races/:name/media.
  const eventId = race.mediaEventId || race.slug
  const organizationName = race.mediaOrgId || PHOTO_DIST_ORG

  return (
    <Container maxWidth='xl' sx={{ mt: 6 }}>
      <Typography variant='h4' gutterBottom>{race.title}</Typography>
      <Typography variant='subtitle1' color='text.secondary' gutterBottom>
        {t('media.photographerUploadIntro')}
      </Typography>
      <Box sx={{ mt: 3 }}>
        <UploadWidget apiBaseUrl={PHOTO_DIST_API_BASE} eventId={eventId} organizationName={organizationName} />
      </Box>
    </Container>
  )
}

export default PhotoUpload
